/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-06 22:45:11
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-28 15:37:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductsLinkProduct/Components/ServiceDetail/index.tsx
 */
import { Input, Radio, SectionCollapse, Table } from '@/src/components/Antd';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { request_getVirtualProduct } from '@/src/request/salesChannel/product';
import { Icon } from '@/src/tools/icon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TcTable from 'src/constrains/TermsAndConditionsTableSelection';

import { uuid } from '@/src/tools/helper';
import styles from './style.module.less';
// import { Form } from 'src/components/Antd';

// const Item = Form.Item;
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export const collapseId = 'salesChannelLinkProductServiceLanguage';

type Props = {
  productUuid: string;
  services: Array<any>;
  handleChangePlaceholder: (uuid: string, index: number, value: string) => void;
  handleChangeServiceOptions: (
    uuid: string,
    serviceIndex: number,
    index: number,
    value: string,
  ) => void;
  handleChangeTitle: (uuid: string, index: number, value: string) => void;
  uuid: string;
  handleOnDetailsTcChange: (uuid: string, value: any) => void;
  termsAndConditions: Array<any>;
  termsAndConditionList: Array<any>;
  isOnPrimaryLanguage: boolean;
  title: string;
  disabled?: boolean;
};

function ServiceDetail({
  services,
  productUuid,
  handleChangePlaceholder,
  handleChangeServiceOptions,
  handleChangeTitle,
  handleOnDetailsTcChange,
  termsAndConditions,
  uuid: _uuid,
  termsAndConditionList,
  isOnPrimaryLanguage,
  title,
  disabled,
}: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [storeProductServices, setService] = useState<Array<any>>([]);

  useEffect(() => {
    request_getVirtualProduct(productUuid, { requestSourceID: uuid() }).then(
      (res) => {
        const { productService } = res || ({} as any);
        setService(productService.serviceDetails || []);
      },
    );
  }, [productUuid]);

  const columns = (serviceIndex: number) => {
    return [
      {
        dataIndex: 'value',
        title: getI18n('salesChannelProductDetail.index.options'),
        width: '50%',
        render: (text: any) => {
          return <span>{text?.value}</span>;
        },
      },
      {
        title: getI18n(
          'salesChannelProductDetail.index.optionslabelinthislanguage',
        ),
        width: '50%',
        render: (text: string, record: any, index: number) => {
          return (
            <Input
              size='large'
              className={styles.tableInput}
              value={services[serviceIndex].options[index].value}
              disabled={disabled}
              error={!!!services[serviceIndex].options[index].value}
              onChange={handleChangeServiceOptions.bind(
                this,
                _uuid,
                serviceIndex,
                index,
              )}
            />
          );
        },
      },
    ];
  };

  const dataSource = (options) => {
    return Array.isArray(options) ? options.map((v) => ({ value: v })) : [];
  };

  const renderTitle = () => {
    return (
      <div className={styles.title}>
        <div className={'collapseTitle'}>{title}</div>
      </div>
    );
  };

  const renderBottom = () => {
    return (
      <div className={styles.bottom}>
        <Icon type='iconinfo' className={styles.icon} />
        <span>
          {`${getI18n('general.gotoStore')} > `}
          <Link to={'/productsList'}>
            {getI18n('general.storeCommunicationSetting.product')}
          </Link>
          {getI18n(
            'salesChannelProductDetail.index.managevirtualproductdetail',
          )}
        </span>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.content}>
        {services.map((service, index: number) => {
          return (
            <div className={styles.item} key={service.uuid}>
              <div className={styles.line1}>
                <div className={styles.fieldTitle}>
                  <div className={styles.title}>
                    <span>{`${getI18n(
                      'salesChannelProductDetail.index.fieldTitle',
                    )} - ${service.title || ''}`}</span>
                    <span className={styles.limit}>{`${
                      service.title?.length || 0
                    }/50`}</span>
                  </div>
                  <div className={styles.subTitle}>
                    <span>
                      {getI18n(
                        'salesChannelProductDetail.index.editthefieldtitleinthislanguage',
                      )}
                    </span>
                  </div>
                  <div className={styles.titleInput}>
                    <Input
                      maxLength={50}
                      size='large'
                      className={styles.titleInputField}
                      value={service.title}
                      disabled={disabled}
                      onChange={handleChangeTitle.bind(this, _uuid, index)}
                    />
                  </div>
                </div>
                {service.type === 'Text' && (
                  <div className={styles.fieldPlaceholder}>
                    <div className={styles.title}>
                      <span>
                        {getI18n(
                          'salesChannelProductDetail.index.contentFieldPlaceholder',
                        )}
                      </span>
                      <span className={styles.limit}>{`${
                        (service.placeHolder || '').length || 0
                      }/200`}</span>
                    </div>
                    <div className={styles.subTitle}>
                      <span>
                        {getI18n(
                          'salesChannelProductDetail.index.editthefieldtitleinthislanguage',
                        )}
                      </span>
                    </div>
                    <div className={styles.placeholderInput}>
                      <Input
                        maxLength={200}
                        size='large'
                        className={styles.placeholderInputField}
                        value={service.placeHolder}
                        disabled={disabled}
                        onChange={handleChangePlaceholder.bind(
                          this,
                          _uuid,
                          index,
                        )}
                      />
                    </div>
                  </div>
                )}
                {service.type !== 'Text' && (
                  <div className={styles.fieldSelection}>
                    <div className={styles.title}>
                      <span>
                        {getI18n(
                          'salesChannelProductDetail.index.selectionType',
                        )}
                      </span>
                    </div>
                    <div className={styles.radio}>
                      <Radio
                        value={service.type}
                        radioList={[
                          {
                            value: 'Radio',
                            label: getI18n(
                              'salesChannelProductDetail.index.singleRadiobutton',
                            ),
                            disable: true,
                          },
                          {
                            value: 'Checkbox',
                            label: getI18n(
                              'salesChannelProductDetail.index.multipleCheckbox',
                            ),
                            disable: true,
                          },
                        ]}
                      />
                    </div>
                  </div>
                )}
              </div>
              {service.type !== 'Text' &&
                Array.isArray(storeProductServices[index]?.options) && (
                  <div className={styles.line2}>
                    <Table
                      scroll={{ y: 383 }}
                      rowKey={'value'}
                      columns={columns(index)}
                      dataSource={dataSource(
                        storeProductServices[index].options,
                      )}
                      pagination={false}
                    />
                  </div>
                )}
            </div>
          );
        })}
        {renderBottom()}
        {true && (
          <Section className={styles.tcContainer}>
            <div className={styles.tcTitle}>
              {getI18n(
                'salesChannelProductDetail.index.serviceTermsConditions',
              )}
            </div>
            <TcTable
              data={termsAndConditions}
              onChange={(tc) => {
                handleOnDetailsTcChange(_uuid, tc);
              }}
              setHasModified={() => {
                console.log('');
              }}
              tcs={termsAndConditionList || []}
              error={{}}
              id={`${_uuid}SalesChannelProductsTc`}
              disableEdit={disabled}
            />
          </Section>
        )}
      </div>
    );
  };
  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={`${collapseId}-${productUuid}`}
        titleStyle={{ height: '64px' }}
        title={renderTitle()}
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default ServiceDetail;
